/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { getNightWordByQuantity } from '../../../Utils/DateUtil';
import 'swiper/css';
import './css/ToursBar.css';
import { TOUR_ID } from '../../../Utils/Constants/urlParams';
import { NIGHT } from '../../../Utils/Constants/GlobalConstants';
import { ReactComponent as BlueArrow } from '../../../images/blue_buttom_arrow-r.svg';
import Portal from './Portal';
import PriceText from '../../PriceText/PriceText';
import { changeOtherToursCoords } from '../../../DataStore/actions/searchFormActions';
import { getShortString, formatPrice } from '../../../Utils/CommonUtils';

import { ReactComponent as TooltipIco } from '../../../images/gray-tooltip-r.svg';
import { placement } from '../../../Utils/Constants/Placement';

const mapStateToProps = (state) => ({ ...state });

class ToursBar extends React.Component {
  constructor(props) {
    super(props);

    this.swipeRef = React.createRef();

    this.state = {
      activeIndex: 0,
      lastIndex: 0,
    };
  }

  slideLeft = () => {
    if (this.swipeRef.current) {
      this.swipeRef.current.slideNext();
    }
  };

  slideRight = () => {
    if (this.swipeRef.current) {
      this.swipeRef.current.slidePrev();
    }
  };

  handleOutsideClick = (e) => {
    const { groupedByDate, setGroupedByDate } = this.props;

    if (this.nodeRef && this.nodeRef.contains(e.target)) {
      return;
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    const groupedByDatesToursCopy = [...groupedByDate];
    for (let i = 0; i < groupedByDatesToursCopy.length; i++) {
      const groupDate = groupedByDatesToursCopy[i];
      const dateRooms = groupDate.rooms;

      for (let j = 0; j < dateRooms.length; j++) {
        const dRoom = dateRooms[j];
        const roomNights = dRoom.nights;

        for (let k = 0; k < roomNights.length; k++) {
          const nights = roomNights[k];
          const { meals: mealss } = nights;

          for (let l = 0; l < mealss.length; l++) {
            const meal = mealss[l];

            if (meal.id === this.mealID) {
              meal.otherOffersVisible = false;
              setGroupedByDate(groupedByDatesToursCopy);
            }
          }
        }
      }
    }
  };

  changeOtherOffersVisibility = (mealId, mealOthersRef) => {
    document.removeEventListener('click', this.handleOutsideClick, false);

    const {
      setGroupedByDate,
      groupedByDate,
      roomRef,
      changeOtherToursCoords: changeOtherToursCoordsAction,
    } = this.props;
    if (mealOthersRef && roomRef.current) {
      const rect = mealOthersRef.getBoundingClientRect();
      const roomRect = roomRef.current.getBoundingClientRect();

      changeOtherToursCoordsAction({
        top: rect.top - roomRect.top + 20,
        left: rect.left - roomRect.left - 43,
      });
    }

    this.mealID = mealId;
    this.nodeRef = mealOthersRef;

    const groupedByDatesToursCopy = [...groupedByDate];
    for (let i = 0; i < groupedByDatesToursCopy.length; i++) {
      const groupDate = groupedByDatesToursCopy[i];
      const dateRooms = groupDate.rooms;
      for (let j = 0; j < dateRooms.length; j++) {
        const dRoom = dateRooms[j];
        const roomNights = dRoom.nights;
        for (let k = 0; k < roomNights.length; k++) {
          const nights = roomNights[k];
          const { meals: mealss } = nights;

          for (let l = 0; l < mealss.length; l++) {
            const meal = mealss[l];

            if (meal.id === mealId) {
              if (meal.otherOffersVisible) {
                meal.otherOffersVisible = false;
              } else {
                meal.otherOffersVisible = true;
                document.addEventListener(
                  'click',
                  this.handleOutsideClick,
                  false,
                );
              }
            } else {
              meal.otherOffersVisible = false;
            }
          }
        }
      }
    }

    setGroupedByDate(groupedByDatesToursCopy);
  };

  getOfferWord = (other) => {
    let word = '';
    if (other <= 1) {
      word = 'предложение';
    } else if (other <= 4) {
      word = 'предложения';
    } else {
      word = 'предложений';
    }

    return word;
  };

  buildOrderUrl = (tourId) => {
    const queryParameters = new URLSearchParams();
    queryParameters.append(TOUR_ID, tourId);

    return `/tour?${queryParameters.toString()}`;
  };

  renderMealsPrice = (tour) => (
    <div className="tb_tour_meal_price_w">
      <Link
        className="tb_tour_button"
        target="_blank"
        to={this.buildOrderUrl(tour.id)}
      >
        <div>
          <PriceText text={`${formatPrice(tour.price)} ${tour.currency}`} />
        </div>
      </Link>
      <div className="br_text_14 mb_8">
        <PriceText
          text={`${formatPrice(tour.pricePerNight)} ${tour.currency} / ${NIGHT}`}
        />
      </div>
      <div className="gr_text_16 mb_6">{tour.operator.name}</div>
    </div>
  );

  getTooltipText = (text) => {
    let description = '';

    const name = text.replaceAll(' ', '');
    const filterdPlacement = placement.filter((e) => e.name === name);

    if (filterdPlacement.length > 0) {
      description = filterdPlacement[0].description;
    }

    return description;
  };

  renderOtherOffers = (tours) =>
    tours.map((tour, index) => {
      const tooltipContent = this.getTooltipText(tour.placement);

      return (
        <div className="tb_other_options" key={`tour-${index}`}>
          <Link
            className="tb_other_offer_link"
            target="_blank"
            to={this.buildOrderUrl(tour.id)}
          >
            <div className="tb_price_line br_text_14">
              <div>{getShortString(tour.operator.name, 15)}</div>
              <div className="bm_text_14">
                {' '}
                <PriceText
                  text={`${formatPrice(tour.price)} ${tour.currency}`}
                />
              </div>
            </div>
            <div className="tb_placement_w">
              <div className="gm_text_12">{tour.placement}</div>
              {tooltipContent.length > 0 && (
                <div>
                  <div
                    data-tooltip-id={`tour-${index}`}
                    data-tooltip-content={tooltipContent}
                  >
                    <TooltipIco className="tb_tooltip_ico" />
                  </div>
                  <Tooltip id={`tour-${index}`} />
                </div>
              )}
            </div>
          </Link>
        </div>
      );
    });

  renderNightsMeals = (meals, col) =>
    meals.map((item, index) => {
      const { date, room } = this.props;
      let other = 0;
      let otherTours = [];
      if (item.tours.length > 1) {
        other = item.tours.length - 1;
        otherTours = item.tours.slice(1);
      }

      let otherOffersRef;

      return (
        <div className="tb_meal_w" key={`meal-${index}`}>
          {item.meal && (
            <div className="tb_meal_item">
              <div className="bm_text_12 mb_12">{`${item.meal}`}</div>
              {this.renderMealsPrice(item.tours[0])}

              {other !== 0 && (
                <div
                  className="tb_other_w"
                  ref={(nod) => {
                    otherOffersRef = nod;
                  }}
                >
                  <button
                    type="button"
                    className="tb_other_button"
                    onClick={() => {
                      this.changeOtherOffersVisibility(item.id, otherOffersRef);
                    }}
                  >
                    <div className="other_options_text tb_other_button_text">{`еще ${other} ${this.getOfferWord(
                      other,
                    )}`}</div>
                    <BlueArrow />
                  </button>
                  {item.otherOffersVisible && (
                    <Portal
                      date={date}
                      room={room.roomType.replace(' ', '_')}
                      col={col}
                      row={index}
                    >
                      <div className="tb_other_options_w">
                        {this.renderOtherOffers(otherTours)}
                      </div>
                    </Portal>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      );
    });

  renderSlides = (nights) =>
    nights.map((night, index) => (
      <SwiperSlide key={`slide-${index}`}>
        <div className="tb_night_w">
          <div className="tb_mights_title_w">
            <div className="tb_night_title">{`${
              night.nightsCount
            } ${getNightWordByQuantity(night.nightsCount)}`}</div>
            <div className="gr_text_14">{`до ${night.tillDate}`}</div>
          </div>

          {this.renderNightsMeals(night.meals, index)}
        </div>
      </SwiperSlide>
    ));

  getLeftButton = () => {
    const { activeIndex } = this.state;
    if (activeIndex === 0) {
      return <div className="tb_inactive_swipe_button_left"></div>;
    } else {
      return (
        <button
          type="button"
          className="tb_swipe_button_left"
          onClick={() => this.slideRight()}
        ></button>
      );
    }
  };

  getRightButton = () => {
    const { activeIndex, lastIndex } = this.state;

    if (lastIndex <= 0 || activeIndex === lastIndex) {
      return <div className="tb_inactive_swipe_button_right"></div>;
    } else {
      return (
        <button
          type="button"
          className="tb_swipe_button_right"
          onClick={() => this.slideLeft()}
        ></button>
      );
    }
  };

  handleSwiperEvent = (swiper) => {
    if (swiper.slides.length > 0) {
      this.setState({
        lastIndex: swiper.slides.length - swiper.params.slidesPerView,
      });
    }
  };

  isSwiperReadyForRender = (room) => room && room.nights.length > 0;

  render() {
    const { lastIndex } = this.state;
    const { room } = this.props;

    return (
      <div className="tb_wrapper">
        <div className="tb_swiper_w">
          {this.isSwiperReadyForRender(room) && (
            <Swiper
              modules={[Pagination, Scrollbar, A11y]}
              spaceBetween={0}
              onSlideChange={(swiper) =>
                this.setState({ activeIndex: swiper.activeIndex })
              }
              observer
              observeParents
              slidesPerView="auto"
              onBreakpoint={(swiper) => {
                this.handleSwiperEvent(swiper);
              }}
              onSwiper={(swiper) => {
                this.handleSwiperEvent(swiper);
                this.swipeRef.current = swiper;
              }}
              breakpoints={{
                650: {
                  slidesPerView: 2,
                },
                932: {
                  slidesPerView: 3,
                },
                1180: {
                  slidesPerView: 4,
                },
              }}
            >
              {this.renderSlides(room.nights)}
            </Swiper>
          )}
        </div>
        {lastIndex > 0 && (
          <div className="tb_buttons_w">
            {this.getLeftButton()}
            {this.getRightButton()}
          </div>
        )}
      </div>
    );
  }
}

ToursBar.propTypes = {
  date: PropTypes.string.isRequired,
  room: PropTypes.instanceOf(Object).isRequired,
  setGroupedByDate: PropTypes.func.isRequired,
  groupedByDate: PropTypes.instanceOf(Array).isRequired,
  roomRef: PropTypes.instanceOf(Object).isRequired,
  changeOtherToursCoords: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeOtherToursCoords })(ToursBar);
